import { COLOR_PRIMARY } from 'constants/color';
import { MESSAGE_SHARE_THIS_APP } from 'constants/message';
import React from 'react';
import { Platform, Share, TouchableOpacity } from 'react-native';
import { Entypo } from '@expo/vector-icons';

const ShareThisApp: React.VFC = () => {
	const handleShare = async () => {
		try {
			await Share.share({
				message: MESSAGE_SHARE_THIS_APP,
			});
		} catch (error) {
			alert(error.message);
		}
	};

	if (Platform.OS === 'web') return null;
	return (
		<TouchableOpacity onPress={handleShare}>
			<Entypo name="share" size={24} color={COLOR_PRIMARY} />
		</TouchableOpacity>
	);
};

export default ShareThisApp;
